<!--  -->
<template>
   <!-- 缺省页 -->
    <div class="noData">
      <div>
        <img src="@/assets/img/car/noCar.png" alt="">
        <span>目前没有添加商品哦～</span>
      </div>
    </div>
</template>

<script>

export default {

  data() {
    return {

    };
  },

  components: {

  },

  computed: {},

  mounted() {},

  created() {
  },

  methods: {

  },

};
</script>
<style lang="scss" scoped>
  .noData{
    display: flex;
    justify-content: center;
    align-items: center;
    padding-bottom: 300px;
    div{
      img{
        width: 360px;
        height: 360px;
      }
      span{
        display: block;
        font-size: 28px;
        font-weight: 400;
        color: #787878;
        line-height: 40px;
        text-align: center;
      }

    }
  }
</style>
